import axios from '../requester';
import { API } from '../constants/api-urls';

export const getIterationsFromSync = async ({
  sensorAuth,
  selectedProviderIds = []
}) =>
  axios.get(
    `${API.PM_PROVIDER_SYNC_PATH}?sensor_authorization_id=${
      sensorAuth && sensorAuth.id
    }${
      selectedProviderIds.length
        ? `&board_provider_id=${selectedProviderIds.join(',')}`
        : ''
    }`
  );
export const getIterations = async params =>
  axios.get(API.ITERATIONS_PATH, { params });

export const getDefaultIterations = async params =>
  axios.get(`${API.ITERATIONS_PATH}/default`, {
    params: {
      ...params,
      limit: 300
    }
  });

export const getIterationsStats = async params =>
  axios.get(`${API.ITERATIONS_PATH}/stats`, {
    params: new URLSearchParams(params)
  });
